import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/joy';

const ONLINE_WINDOW_MS = 2 * 60 * 1000; // 2 minutes

export const DroneStatusTag = ({ last }: { last: Date | undefined | null }): React.ReactElement => {
  const { t } = useTranslation();

  if (!last)
    return (
      <Box component='span' title='No heartbeat'>
        {t('drones.status.offline')}
      </Box>
    );

  const now = new Date();
  const online = now.getTime() - last.getTime() < ONLINE_WINDOW_MS;

  return (
    <Box
      className={
        online
          ? 'bg-green-900 px-2 py-1 rounded-2xl w-auto h-auto text-sm'
          : 'border border-solid bg-black px-2 py-1 rounded-2xl'
      }
      component='span'
      sx={{ color: online ? 'white' : 'text.tertiary' }}
      title={last.toLocaleString()}
    >
      {t(online ? 'drones.status.online' : 'drones.status.offline')}
    </Box>
  );
};
